import React, {Component} from'react';
import memont from 'moment';
import {Modal} from 'react-bootstrap';
import {tryAddConstuction} from 'actions/ConstructionActions';

class ConstructionCreateModal extends Component{
  constructor(props) {
    super(props);

    this.state = {
      constructionName: "",
      constructionNameErrorMsg: "",
      year: memont().year(),
      assignTo: this.props.companyList.getIn([0, 'id'])
    }
  }

  handleCreateConstruction = () => {
    let {constructionName, year, assignTo} = this.state;

    this.props.dispatch(tryAddConstuction(constructionName, year, assignTo, this.props.handleDisMissModal));
  }

  nameValidtor = (name) => {
    let len = name.length;
    if (len === 0) return "工程名稱不能為空"
    if (len > 45) return "工程名稱長度必須小於 45"
    return "";
  }

  handldeNameChange = (e) => {
    let name = e.target.value;
    this.setState({
      constructionName: name, 
      constructionNameErrorMsg: this.nameValidtor(name)
    })
  }

  handleYear = (e) => {
    this.setState({year: parseInt(e.target.value, 10) || memont().year() + 1})
  }

  handleAssginTo = (e) => {
    this.setState({assignTo: e.target.value})
  }

  render() {
    let {handleDisMissModal, companyList} = this.props;
    let {constructionName, constructionNameErrorMsg, year, assignTo} = this.state;

    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>
            新增工程
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className="form-horizontal">
            <div className="form-group">
              <label className="col-sm-3 control-label">工程年份</label>
              <div className="col-sm-9">
                <select 
                  className="form-control" 
                  value={year} 
                  onChange={this.handleYear}>
                  {Array.from(Array(5), (x, i) => year - (i + 1)).reverse().map(y => (
                      <option value={y} key={y}>{y}</option>
                    ))
                  }
                  <option value={year} key={year}>{year}</option>
                  {Array.from(Array(5), (x, i) => year + i + 1).map(y => (
                      <option value={y} key={y}>{y}</option>
                    ))
                  }
                </select>         
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-3 control-label">工程名稱</label>
              <div className="col-sm-9">
                <input
                  type="text"
                  value={constructionName}
                  onChange={this.handldeNameChange}
                  className="form-control"
                />
                {constructionNameErrorMsg.length > 0 &&
                  <span className="error-msg">
                    - {constructionNameErrorMsg}
                  </span>}                
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-3 control-label">執行公司</label>
              <div className="col-sm-9">
                <select 
                  className="form-control" 
                  value={assignTo} 
                  onChange={this.handleAssginTo}>
                  {companyList.map((company) => (
                    <option value={company.get('id')} key={company.get('id')}>
                      {company.get('name')}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button 
            className="btn btn-primary"
            onClick={this.handleCreateConstruction}>
            新增
          </button>
          {" "}
          <button 
            className="btn btn-default"
            onClick={handleDisMissModal}>
            關閉
          </button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

export default ConstructionCreateModal;


// WEBPACK FOOTER //
// ./src/components/Construction/ConstructionCreateModal.js